<template>
  <v-card flat class="pa-4">
    <!-- Snackbar -->
    <v-snackbar v-model="mensaje.snackbar" :timeout="mensaje.timeout" :color="mensaje.color" text top right>
      {{ mensaje.text }}
      <template v-slot:action="{ attrs }">
        <v-btn :color="mensaje.colorBtn" text v-bind="attrs" @click="mensaje.snackbar = false">Cerrar</v-btn>
      </template>
    </v-snackbar>

    <h3 class="mb-3">Gestión de Roles</h3>
    <p class="caption grey--text mb-4">Asignar o quitar roles a los usuarios del sistema.</p>

    <!-- Buscador -->
    <v-row class="mb-3">
      <v-col cols="12" sm="6">
        <v-text-field v-model="busqueda" label="Buscar usuario por nombre o email"
          outlined dense hide-details prepend-inner-icon="mdi-magnify" clearable>
        </v-text-field>
      </v-col>
    </v-row>

    <!-- Tabla -->
    <v-data-table
      :headers="headers"
      :items="users"
      :search="busqueda"
      :loading="loading"
      loading-text="Cargando usuarios..."
      no-data-text="No hay usuarios"
      class="elevation-1"
      :footer-props="{ 'items-per-page-options': [10, 20, 50] }"
    >
      <template v-slot:item.roles="{ item }">
        <v-chip v-for="role in item.roles" :key="role.id" small class="mr-1"
          :color="role.name === 'admin' ? 'red lighten-4' : 'blue lighten-4'">
          {{ role.name }}
        </v-chip>
        <span v-if="!item.roles || !item.roles.length" class="caption grey--text">Sin rol</span>
      </template>
      <template v-slot:item.created_at="{ item }">
        {{ formatDate(item.created_at) }}
      </template>
      <template v-slot:item.acciones="{ item }">
        <v-btn small color="primary" @click="openEditDialog(item)">
          <v-icon left small>mdi-pencil</v-icon> Roles
        </v-btn>
      </template>
    </v-data-table>

    <!-- Dialog editar roles -->
    <v-dialog v-model="dialogEdit" max-width="400" persistent>
      <v-card>
        <v-card-title>Roles de {{ editUser ? editUser.name : '' }}</v-card-title>
        <v-card-subtitle class="pb-0">{{ editUser ? editUser.email : '' }}</v-card-subtitle>
        <v-card-text class="pt-3">
          <v-checkbox v-for="role in rolesDisponibles" :key="role.id"
            v-model="selectedRoles" :label="role.name" :value="role.name"
            hide-details dense class="mb-1">
          </v-checkbox>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogEdit = false">Cancelar</v-btn>
          <v-btn color="primary" dark :loading="saving" @click="guardarRoles">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import adminService from '@/services/adminService.js';

export default {
  name: 'RolesAdmin',
  data() {
    return {
      users: [],
      rolesDisponibles: [],
      busqueda: '',
      loading: false,
      dialogEdit: false,
      editUser: null,
      selectedRoles: [],
      saving: false,
      headers: [
        { text: 'ID', value: 'id', width: '60px' },
        { text: 'Nombre', value: 'name' },
        { text: 'Email', value: 'email' },
        { text: 'Identificador', value: 'identificador' },
        { text: 'Roles', value: 'roles', sortable: false },
        { text: 'Registrado', value: 'created_at' },
        { text: 'Acciones', value: 'acciones', sortable: false }
      ],
      mensaje: {
        snackbar: false,
        text: '',
        color: '',
        colorBtn: '',
        timeout: 4000
      }
    };
  },
  mounted() {
    this.cargarUsers();
    this.cargarRoles();
  },
  methods: {
    cargarUsers() {
      this.loading = true;
      adminService.listUsers().then(res => {
        this.users = res.data;
      }).finally(() => {
        this.loading = false;
      });
    },
    cargarRoles() {
      adminService.listRoles().then(res => {
        this.rolesDisponibles = res.data;
      });
    },
    openEditDialog(user) {
      this.editUser = user;
      this.selectedRoles = user.roles ? user.roles.map(r => r.name) : [];
      this.dialogEdit = true;
    },
    guardarRoles() {
      if (!this.editUser) return;
      this.saving = true;
      adminService.updateUserRoles(this.editUser.id, this.selectedRoles).then(() => {
        this.showMsg('Roles actualizados para ' + this.editUser.name, 'success');
        this.dialogEdit = false;
        this.cargarUsers();
      }).catch(err => {
        const errors = err.response && err.response.data && err.response.data.errors;
        this.showMsg(errors ? errors.join(', ') : 'Error al actualizar roles', 'error');
      }).finally(() => {
        this.saving = false;
      });
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      return d.toLocaleDateString('es', { day: '2-digit', month: 'short', year: 'numeric' });
    },
    showMsg(text, type) {
      this.mensaje.text = text;
      this.mensaje.color = type === 'success' ? 'success' : 'error';
      this.mensaje.colorBtn = type === 'success' ? 'green darken-1' : 'red darken-1';
      this.mensaje.snackbar = true;
    }
  }
};
</script>
